import { type MouseEvent, type MouseEventHandler } from 'react';

/**
 * We want to keep focus in the editor as much as possible. If you
 * attach an onClick to something outside the editor, it will grab
 * focus when the onMouseDown fires. If that thing disappears when the
 * editor loses focus, like a popup menu, it will hide before the
 * click event fires on it, and the click will never happen.
 *
 * On the other hand, if you use onMouseDown to take an action, and
 * the onMouseDown causes the menu to disappear, the mouseUp /
 * mouseOver / click events will happen on the thing _behind_ the
 * menu, which is probably also not what you want. Besides that, it
 * feels like the menu disappears too quickly.
 *
 * This function wraps an "onClick" handler to disable focus-stealing
 * in the onMouseDown and trigger on mouseup instead.
 *
 * Usage: <div className="something" {...onClickWithoutFocus((e) => console.log("clicked!"))} />
 */
export default function onClickWithoutFocus(onClick: MouseEventHandler) {
  return {
    onMouseDown: (event: MouseEvent) => {
      event.preventDefault();
    },
    onMouseUp: onClick,
  };
}
